import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const StackBarGraph = ({ data }) => {
  const modifiedData = data.map((item) => {
    const planned = parseFloat(item.total_planned_modules) || 0;
    const produced = parseFloat(item.produced_modules) || 0;
    const pdi = parseFloat(item.module_count_pdi) || 0;
    const shipped = parseFloat(item.no_of_modules_shipped) || 0;

    return {
      ...item,
      supplier_label: `${item.supplier_name} (${item.module_wattage})`,
      shipped,
      pdi_pending: Math.max(0, pdi - shipped),
      produced_pending: Math.max(0, produced - pdi),
      planned_pending: Math.max(0, planned - produced),
    };
  });

  const numItems = modifiedData.length;
  const itemHeight = 55; // px per supplier — adjust up/down for tighter/looser spacing
  const extraPadding = 120; // for legend, axes, title, etc.
  const chartHeight = numItems * itemHeight + extraPadding;
  const minHeight = 300; // prevent too small when very few items
  const finalHeight = Math.max(minHeight, chartHeight);

  const chartData = {
    labels: modifiedData.map((item) => item.supplier_label),
    datasets: [
      {
        label: "Shipped Modules",
        data: modifiedData.map((item) => item.shipped),
        backgroundColor: "#FF6384",
      },
      {
        label: "PDI Completed (Pending Shipment)",
        data: modifiedData.map((item) => item.pdi_pending),
        backgroundColor: "#82ca9d",
      },
      {
        label: "Produced (Pending PDI)",
        data: modifiedData.map((item) => item.produced_pending),
        backgroundColor: "#36A2EB",
      },
      {
        label: "Planned (Not Produced)",
        data: modifiedData.map((item) => item.planned_pending),
        backgroundColor: "#8884d8",
      },
    ],
  };

  const options = {
    indexAxis: "y", // Horizontal bars
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
        beginAtZero: true,
      },
      y: {
        stacked: true,
      },
    },
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <div style={{ height: `${finalHeight}px`, width: "100%" }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default StackBarGraph;